import config from '@/utils/ApiUtils'
import { fetchWithToken } from '../utils/Keycloak'

export default {
  sendMail(expediteur, destinataires, contenu, pieceJointe = [], cc = [], cci = []) {
    return fetchWithToken(config().mailSenderBackend + 'send-mail', {
      method: 'POST',
      body: JSON.stringify({ expediteur, destinataires, contenu, pieceJointe, cc, cci })
    }).then(response => response.json())
  },

  /**
   * Envoie un mail via un template enregistré en base (table `template`).
   * @param {Object} payload - { type, mail, subject, ...variables du template }
   * @returns {Promise<{ id: string }>} - id = sid Mailjet pour le suivi du statut
   */
  sendTemplatedMail(payload) {
    return fetchWithToken(config().mailSenderBackend + 'mail', {
      method: 'POST',
      body: JSON.stringify(payload)
    }).then(response => response.json())
  },

  // --- Boîte de réception (Gmail de l'utilisateur de la session) ---

  getInboxStatus() {
    return fetchWithToken(config().mailSenderBackend + 'inbox/status', {
      method: 'GET'
    }).then(response => response.json())
  },

  getInbox({ limit = 25, pageToken = '', search = '' } = {}) {
    const params = new URLSearchParams({ limit })
    if (pageToken) params.append('pageToken', pageToken)
    if (search) params.append('search', search)
    return fetchWithToken(config().mailSenderBackend + `inbox?${params.toString()}`, {
      method: 'GET'
    }).then(response => response.json())
  },

  getInboxMessage(messageId) {
    return fetchWithToken(config().mailSenderBackend + `inbox/${messageId}`, {
      method: 'GET'
    }).then(response => response.json())
  },

  // --- Actions sur la boîte de réception ---

  getInboxAttachment(messageId, attachmentId) {
    return fetchWithToken(config().mailSenderBackend + `inbox/${messageId}/attachment/${attachmentId}`, {
      method: 'GET'
    }).then(response => response.json())
  },

  setInboxMessageRead(messageId, read) {
    return fetchWithToken(config().mailSenderBackend + `inbox/${messageId}/read`, {
      method: 'POST',
      body: JSON.stringify({ read })
    }).then(response => response.json())
  },

  trashInboxMessage(messageId) {
    return fetchWithToken(config().mailSenderBackend + `inbox/${messageId}/trash`, {
      method: 'POST'
    }).then(response => response.json())
  },

  replyToInboxMessage(messageId, payload) {
    return fetchWithToken(config().mailSenderBackend + `inbox/${messageId}/reply`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }).then(response => response.json())
  },

  forwardInboxMessage(messageId, payload) {
    return fetchWithToken(config().mailSenderBackend + `inbox/${messageId}/forward`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }).then(response => response.json())
  },

  getHistory({ limit = 50, offset = 0, search = '', recipients = '' } = {}) {
    const params = new URLSearchParams({ limit, offset })
    if (search) params.append('search', search)
    if (recipients) params.append('recipients', recipients)
    return fetchWithToken(config().mailSenderBackend + `mail/history?${params.toString()}`, {
      method: 'GET'
    }).then(response => response.json())
  },

  getMessageHistory(messageId) {
    return fetchWithToken(config().mailSenderBackend + `message-history/${messageId}`, {
      method: 'GET'
    }).then(response => response.json())
  },

  getMessageDetails(messageId) {
    return fetchWithToken(config().mailSenderBackend + `message/${messageId}`, {
      method: 'GET'
    }).then(response => response.json())
  },

  getMessageStatuses(sids) {
    return fetchWithToken(config().mailSenderBackend + 'messages/statuses', {
      method: 'POST',
      body: JSON.stringify({ sids })
    }).then(response => response.json())
  },

  getCustomTemplates() {
    return fetchWithToken(config().mailSenderBackend + 'template/custom', {
      method: 'GET'
    }).then(response => response.json())
  },

  saveCustomTemplate(template) {
    return fetchWithToken(config().mailSenderBackend + 'template/custom', {
      method: 'POST',
      body: JSON.stringify(template)
    }).then(response => response.json())
  },

  deleteCustomTemplate(templateId) {
    return fetchWithToken(config().mailSenderBackend + `template/custom/${templateId}`, {
      method: 'DELETE'
    }).then(response => response.json())
  },

  getRecipientFilters() {
    return fetchWithToken(config().mailSenderBackend + 'filter', {
      method: 'GET'
    }).then(response => response.json())
  },

  saveRecipientFilter(filter) {
    return fetchWithToken(config().mailSenderBackend + 'filter', {
      method: 'POST',
      body: JSON.stringify(filter)
    }).then(response => response.json())
  },

  deleteRecipientFilter(filterId) {
    return fetchWithToken(config().mailSenderBackend + `filter/${filterId}`, {
      method: 'DELETE'
    }).then(response => response.json())
  },
}
